import type { AdPlacement } from '../types';

export const adPlacementOptions: Array<{ value: AdPlacement; label: string; helper: string }> = [
  { value: 'home_top', label: 'Topo da Home', helper: 'Banner principal entre o hero e o feed' },
  { value: 'home_feed', label: 'Home / Feed', helper: 'Bloco nativo entre as notícias' },
  { value: 'article_inline', label: 'Artigo - Meio', helper: 'Entre a introdução e o conteúdo' },
  { value: 'article_bottom', label: 'Artigo - Rodapé', helper: 'Antes dos artigos relacionados' },
  { value: 'footer', label: 'Rodapé', helper: 'Faixa discreta no rodapé' },
  { value: 'sidebar', label: 'Sidebar', helper: 'Lateral desktop' },
];

export const adPlacementLabels: Record<AdPlacement, string> = {
  home_top: 'Topo da Home',
  home_feed: 'Home / Feed',
  article_inline: 'Artigo - Meio',
  article_bottom: 'Artigo - Rodapé',
  footer: 'Rodapé',
  sidebar: 'Sidebar',
};